import React from 'react';
import { ListContractorFilesRequest } from './webservices/list-documentary-library/ListContractorFilesRequest';
import { ListContractorFilesTask } from './webservices/list-documentary-library/ListContractorFilesTask';
import { PsContractorFile } from '../PsContractorFile';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../shared/components/CardBody';
import Paginator from '../../shared/components/Paginator';
import { DocumentaryLibraryTable } from './DocumentaryLibraryTable';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import PropTypes from 'prop-types';
import { CurrentUser } from '../../shared/model/CurrentUser';
import { connect } from 'react-redux';
import FormAutocomplete from '../../shared/components/FormAutocomplete';
import { buildOptions } from '../../shared/utils/OptionsManager';
import { ContractorsOfContractorFilesTask } from './webservices/list-contractors/ContractorsOfContractorFilesTask';
import { ContractorsOfContractorFilesRequest } from './webservices/list-contractors/ContractorsOfContractorFilesRequest';

class DocumentaryLibraryCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            data: [],
            error: '',
            search: props.initialCardState.search,
            loading: false,
            filters: [],
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
            contractors: [],
            contractorError: '',
            contractorLoading: false,
            contractorSelected: [],
        };
    }

    componentDidMount() {
        this.listDocumentaryLibrary();
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const {
            search,
            contractorSelected,
        } = this.state;

        if ( prevState.search !== search ) {
            saveCardState({ search });
        }

        if (contractorSelected !== prevState.contractorSelected) {
            this.listDocumentaryLibrary();
        }
    }

    renderHeaderFilterOptions() {
        const {
            contractors,
            contractorLoading,
            contractorSelected,
        } = this.state;

        return (
            <FormAutocomplete
                col={'col-md-3'}
                meta={{ touched: false, error: '' }}
                label={I18nUtils.tr('TR_CONTRATA')}
                placeholder={I18nUtils.tr('TR_CONTRATA')}
                input={{
                    value: contractorSelected,
                    onBlur: () => null,
                    onChange: selected => this.setState({ contractorSelected: selected }),
                }}
                options={contractors}
                loading={contractorLoading}
                disabled={false}
                onSearch={this.searchContractors}
            />
        );
    }

    render() {
        const {
            currentUser,
        } = this.props;
        const {
            data,
            error,
            search,
            loading,
            pagination,
        } = this.state;

        const canDelete = currentUser.isAdmin() || currentUser.isContractorsManager();

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODOS_LOS_DOCUMENTOS').toUpperCase()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={false}
                                searchText={search}
                                onRefresh={this.listDocumentaryLibrary}
                                onSearch={this.search}
                            />
                        )}
                    />
                    <CardBody>
                        <div>
                            <div className={'row'}>
                                {this.renderHeaderFilterOptions()}
                            </div>
                            <hr/>
                            <DocumentaryLibraryTable
                                data={data}
                                error={error}
                                loading={loading}
                                cleanFiltersHandler={this.cleanFilters}
                                refreshListHandler={this.listDocumentaryLibrary}
                                canDelete={canDelete}
                            />
                        </div>
                    </CardBody>
                    <Paginator
                        data={pagination}
                        onPage={this.selectPage}
                    />
                </Card>
            </Row>
        );
    }

    search = (search) => {
        this.setState({ search, page: 1 }, this.listDocumentaryLibrary);
    };

    selectPage = (page) => {
        this.setState({ page }, this.listDocumentaryLibrary);
    };

    listDocumentaryLibrary = () => {
        const {
            page,
            search,
            contractorSelected,
        } = this.state;
        const request = new ListContractorFilesRequest();

        request.setPage(page);
        request.setTerm(search);
        const contractorId = contractorSelected.length !== 0 ? contractorSelected[0].value : undefined;
        request.setContractorId(contractorId);

        new ListContractorFilesTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess(res => {
                const data = PsContractorFile.fromApiContractorFiles(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail(error => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    cleanFilters = () => {
        this.setState({
            search: '',
            page: 1,
        });
    };

    searchContractors = (value) => {
        if ( !value || value.length === 0 ) {
            return;
        }

        const request = new ContractorsOfContractorFilesRequest();

        request.setPage(null);
        request.setTerm(value);

        new ContractorsOfContractorFilesTask(request)
            .onPreExecution(() => this.setState({ contractorLoading: true }))
            .onSuccess((res) => {
                this.setState({ contractors: buildOptions(res.data) });
            })
            .onFail(error => this.setState({ contractorError: error }))
            .onPostExecution(() => this.setState({ contractorLoading: false }))
            .execute();
    };
}

const mapStateToProps = state => {

    return {
        currentUser: CurrentUser.fromReduxState(state),
    };
};

export default connect(mapStateToProps)(DocumentaryLibraryCard);

DocumentaryLibraryCard.propTypes = {
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object.isRequired,
};

DocumentaryLibraryCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        search: '',
    },
};



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/DocumentaryLibraryCard.jsx